import hljs from 'highlight.js/lib/core'

const languageMap = {
  accesslog: 'accesslog',
  apache: 'apache',
  applescript: 'applescript',
  bash: 'bash',
  basic: 'basic',
  c: 'c',
  coffee: 'coffeescript',
  coffeescript: 'coffeescript',
  cpp: 'cpp',
  crystal: 'crystal',
  csharp: 'csharp',
  csp: 'csp',
  css: 'css',
  dart: 'dart',
  diff: 'diff',
  dockerfile: 'dockerfile',
  elixir: 'elixir',
  elm: 'elm',
  erb: 'erb',
  erlang: 'erlang',
  gherkin: 'gherkin',
  cucumber: 'gherkin',
  go: 'go',
  graphql: 'graphql',
  haml: 'haml',
  handlebars: 'handlebars',
  haskell: 'haskell',
  http: 'http',
  ini: 'ini',
  java: 'java',
  js: 'javascript',
  javascript: 'javascript',
  json: 'json',
  julia: 'julia',
  kotlin: 'kotlin',
  latex: 'latex',
  leaf: 'leaf',
  less: 'less',
  lisp: 'lisp',
  lua: 'lua',
  makefile: 'makefile',
  markdown: 'markdown',
  mathematica: 'mathematica',
  matlab: 'matlab',
  md: 'markdown',
  mysql: 'sql',
  nginx: 'nginx',
  objectivec: 'objectivec',
  ocaml: 'ocaml',
  perl: 'perl',
  php: 'php',
  'php-template': 'php-template',
  plaintext: 'plaintext',
  prolog: 'prolog',
  puppet: 'puppet',
  python: 'python',
  python3: 'python',
  r: 'r',
  rspec: 'ruby',
  ruby: 'ruby',
  rb: 'ruby',
  rust: 'rust',
  scala: 'scala',
  scheme: 'scheme',
  scss: 'scss',
  sass: 'scss',
  shell: 'shell',
  sh: 'bash',
  smalltalk: 'smalltalk',
  sql: 'sql',
  swift: 'swift',
  tex: 'latex',
  typescript: 'typescript',
  vbnet: 'vbnet',
  vbscript: 'vbscript',
  vim: 'vim',
  wasm: 'wasm',
  xml: 'xml',
  html: 'xml',
  yaml: 'yaml',
  yml: 'yaml',
}

up.compiler('.syntax-highlighted', async (code) => {

  let language
  let alias
  for (const cls of code.classList) {
    if (languageMap[cls.toLowerCase()]) {
      alias = cls
      language = languageMap[cls.toLowerCase()]
      break
    }
  }

  // Note: Dynamic import with template literal (e.g., `highlight.js/lib/languages/${language}`) doesn't work here.
  // Esbuild requires static string literals for import paths to correctly bundle the files.
  let languageModule
  switch (language) {
    case 'accesslog':
      languageModule = await import('highlight.js/lib/languages/accesslog')
      break
    case 'apache':
      languageModule = await import('highlight.js/lib/languages/apache')
      break
    case 'applescript':
      languageModule = await import('highlight.js/lib/languages/applescript')
      break
    case 'bash':
      languageModule = await import('highlight.js/lib/languages/bash')
      break
    case 'basic':
      languageModule = await import('highlight.js/lib/languages/basic')
      break
    case 'c':
      languageModule = await import('highlight.js/lib/languages/c')
      break
    case 'coffeescript':
      languageModule = await import('highlight.js/lib/languages/coffeescript')
      break
    case 'cpp':
      languageModule = await import('highlight.js/lib/languages/cpp')
      break
    case 'crystal':
      languageModule = await import('highlight.js/lib/languages/crystal')
      break
    case 'csharp':
      languageModule = await import('highlight.js/lib/languages/csharp')
      break
    case 'csp':
      languageModule = await import('highlight.js/lib/languages/csp')
      break
    case 'css':
      languageModule = await import('highlight.js/lib/languages/css')
      break
    case 'dart':
      languageModule = await import('highlight.js/lib/languages/dart')
      break
    case 'diff':
      languageModule = await import('highlight.js/lib/languages/diff')
      break
    case 'dockerfile':
      languageModule = await import('highlight.js/lib/languages/dockerfile')
      break
    case 'elixir':
      languageModule = await import('highlight.js/lib/languages/elixir')
      break
    case 'elm':
      languageModule = await import('highlight.js/lib/languages/elm')
      break
    case 'erb':
      languageModule = await import('highlight.js/lib/languages/erb')
      break
    case 'erlang':
      languageModule = await import('highlight.js/lib/languages/erlang')
      break
    case 'fsharp':
      languageModule = await import('highlight.js/lib/languages/fsharp')
      break
    case 'gherkin':
      languageModule = await import('highlight.js/lib/languages/gherkin')
      break
    case 'go':
      languageModule = await import('highlight.js/lib/languages/go')
      break
    case 'graphql':
      languageModule = await import('highlight.js/lib/languages/graphql')
      break
    case 'haml':
      languageModule = await import('highlight.js/lib/languages/haml')
      break
    case 'handlebars':
      languageModule = await import('highlight.js/lib/languages/handlebars')
      break
    case 'haskell':
      languageModule = await import('highlight.js/lib/languages/haskell')
      break
    case 'http':
      languageModule = await import('highlight.js/lib/languages/http')
      break
    case 'ini':
      languageModule = await import('highlight.js/lib/languages/ini')
      break
    case 'java':
      languageModule = await import('highlight.js/lib/languages/java')
      break
    case 'javascript':
      languageModule = await import('highlight.js/lib/languages/javascript')
      break
    case 'json':
      languageModule = await import('highlight.js/lib/languages/json')
      break
    case 'julia':
      languageModule = await import('highlight.js/lib/languages/julia')
      break
    case 'kotlin':
      languageModule = await import('highlight.js/lib/languages/kotlin')
      break
    case 'latex':
      languageModule = await import('highlight.js/lib/languages/latex')
      break
    case 'leaf':
      languageModule = await import('highlight.js/lib/languages/leaf')
      break
    case 'less':
      languageModule = await import('highlight.js/lib/languages/less')
      break
    case 'lisp':
      languageModule = await import('highlight.js/lib/languages/lisp')
      break
    case 'lua':
      languageModule = await import('highlight.js/lib/languages/lua')
      break
    case 'makefile':
      languageModule = await import('highlight.js/lib/languages/makefile')
      break
    case 'markdown':
      languageModule = await import('highlight.js/lib/languages/markdown')
      break
    case 'mathematica':
      languageModule = await import('highlight.js/lib/languages/mathematica')
      break
    case 'matlab':
      languageModule = await import('highlight.js/lib/languages/matlab')
      break
    case 'nginx':
      languageModule = await import('highlight.js/lib/languages/nginx')
      break
    case 'objectivec':
      languageModule = await import('highlight.js/lib/languages/objectivec')
      break
    case 'ocaml':
      languageModule = await import('highlight.js/lib/languages/ocaml')
      break
    case 'perl':
      languageModule = await import('highlight.js/lib/languages/perl')
      break
    case 'php':
      languageModule = await import('highlight.js/lib/languages/php')
      break
    case 'php-template':
      languageModule = await import('highlight.js/lib/languages/php-template')
      break
    case 'plaintext':
      languageModule = await import('highlight.js/lib/languages/plaintext')
      break
    case 'prolog':
      languageModule = await import('highlight.js/lib/languages/prolog')
      break
    case 'puppet':
      languageModule = await import('highlight.js/lib/languages/puppet')
      break
    case 'python':
      languageModule = await import('highlight.js/lib/languages/python')
      break
    case 'r':
      languageModule = await import('highlight.js/lib/languages/r')
      break
    case 'ruby':
      languageModule = await import('highlight.js/lib/languages/ruby')
      break
    case 'rust':
      languageModule = await import('highlight.js/lib/languages/rust')
      break
    case 'scala':
      languageModule = await import('highlight.js/lib/languages/scala')
      break
    case 'scheme':
      languageModule = await import('highlight.js/lib/languages/scheme')
      break
    case 'scss':
      languageModule = await import('highlight.js/lib/languages/scss')
      break
    case 'shell':
      languageModule = await import('highlight.js/lib/languages/shell')
      break
    case 'smalltalk':
      languageModule = await import('highlight.js/lib/languages/smalltalk')
      break
    case 'sql':
      languageModule = await import('highlight.js/lib/languages/sql')
      break
    case 'swift':
      languageModule = await import('highlight.js/lib/languages/swift')
      break
    case 'typescript':
      languageModule = await import('highlight.js/lib/languages/typescript')
      break
    case 'vbnet':
      languageModule = await import('highlight.js/lib/languages/vbnet')
      break
    case 'vbscript':
      languageModule = await import('highlight.js/lib/languages/vbscript')
      break
    case 'vim':
      languageModule = await import('highlight.js/lib/languages/vim')
      break
    case 'wasm':
      languageModule = await import('highlight.js/lib/languages/wasm')
      break
    case 'xml':
      languageModule = await import('highlight.js/lib/languages/xml')
      break
    case 'yaml':
      languageModule = await import('highlight.js/lib/languages/yaml')
      break
    default:
      return
  }
  if (languageModule !== 'undefined') {
    if (!hljs.getLanguage(language)) {
      hljs.registerLanguage(alias, languageModule.default)
    }
  }

  hljs.highlightElement(code)
})
